// Xerath — Arcane Barrage: every 3rd auto-attack, unleashes arcane blasts
// at 3 random enemies.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const xerathArcaneBarrage: Ability = {
  id: "xerathArcaneBarrage",
  displayName: "Arcane Barrage",
  description: "Every 3rd attack, blasts 3 random enemies for 1.0× AP + 50 magic damage each.",
  iconId: "XerathW",

  targetShape({ caster, combat }) {
    if (caster.autoAttackCount % 3 !== 0 || caster.autoAttackCount === 0) return [];
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(enemyTeam).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    if (caster.autoAttackCount % 3 !== 0 || caster.autoAttackCount === 0) return [];
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    const stats = effectiveStats(caster);
    const dmg = magicDamage(stats.ap * 1.0 + 35);

    // Pick up to 3 random enemies (shuffle by sort with random key)
    const shuffled = [...enemies].sort(() => Math.random() - 0.5).slice(0, 3);
    return shuffled.map((e, i) => ({
      target: e,
      amount: dmg,
      type: "magical" as const,
      suppressPopup: i > 0,
    }));
  },
};
